import React, { SyntheticEvent, useContext } from "react";
import styles from './previewLayer.module.scss';
import { checkRotationStep, rotationConfig } from "@susu/custom-made/utils/utils";
import cn from 'classnames';
import { ThemeContext } from "@susu/custom-made/providers";
import { Level } from "@susu/custom-made/utils/constants";
import { LayerDefinition } from "@susu/custom-made/utils/preview/layers";
import { Section } from "@susu/custom-made/utils/navigation";

const PreviewRotationLayer = React.memo(({
  layer,
  index,
  keyPrefix,
  onLayerFailed,
  onLayerLoaded,
}: Readonly<{
  layer: LayerDefinition;
  index: number;
  keyPrefix: string;
  onLayerFailed: (e: SyntheticEvent<HTMLImageElement, Event>) => void;
  onLayerLoaded: (e: SyntheticEvent<HTMLImageElement, Event>) => void;
}>) => {
  const { state } = useContext(ThemeContext);

  return (
    <>
      {Object.entries(rotationConfig).map(([key, value]) => (
        <div 
          className={cn(styles.layer, 
            {[styles.isActive]: 
              (!state.animation.status && (
                ((state.level === Level.Group || state.section === Section.Fabric) && key === "front") || 
                (state.level === Level.Subgroup && state.section !== Section.Fabric && 
                  checkRotationStep(state.selectedOption).spriteStep === value.spriteStep)
              ))
            })}
          key={`${keyPrefix}_${index}_${key}`}>
          <img
            src={layer.srcRotation.replaceAll('{rotation}', value.imageSuffix)}
            srcSet={layer.srcsetRotation.replaceAll('{rotation}', value.imageSuffix)}
            alt={`${keyPrefix}_${index}_rotation`}
            onError={onLayerFailed}
            onLoad={onLayerLoaded}
            sizes={layer.sizes}
            fetchPriority="high"
            loading="eager"
          />
        </div>
      ))}
      {state.growthbookFeatures['enable-rotation-animation'] && (
        <div className={cn(styles.layer, styles.layersprite, {[styles.isActive]: state.animation.status})}>
          <img
            src={layer.srcSheet}
            alt={`${keyPrefix}_${index}_sheet`}
            onError={onLayerFailed}
            onLoad={onLayerLoaded}
            sizes={layer.sizes}
            fetchPriority="high"
            loading="eager"
          />
        </div>
      )}
    </>
  );
});

export default PreviewRotationLayer;